import React from 'react'

export default function Welcome() {

    return (
        <div>
            <p className='post__text'>
                With over 30-years of experience in the financial services industry, Germaine Cordes founded Lifetime Capital 
                Financial Group to help her clients achieve financial stability and peace of mind. Her client’s peace of mind 
                comes from knowing that there is a plan designed so their finances are properly coordinated and on the right track. 
                Simply put, Lifetime Capital helps our clients leverage the wealth management solutions available with the focus 
                on achieving and then maintaining your financial independence.
            </p>
            <p className='post__text'>
                We help our clients pursue their goals, by walking them through a step-by-step process that
                provide clarity and solutions. As a “holistic” financial planner, care is taken to optimize wealth
                creation, minimize taxes, and achieve tomorrow’s retirement income needs. The goal, to live a
                better life without worrying about money.
            </p>
            <p className='post__text'>
                We are an independent firm that has formed strategic alliances with some of the largest
                resources available in the financial services industry. These resources provide some of the most
                innovative products and services available so that we may customize financial plans and
                investment solutions to suit our client&#39;s needs.
            </p>
        </div>
    )
}